import Gallery from './ImageGallery';
import ShowcaseDesc from './DescriptionShowcase';
import './ProjectShowcase.css'

function ShowcaseGallery({children, Title = 'Unnamed Project', Date = 'Today', ImgURLs = ['/CookieMissingTexture.png', '/CookieMissingTexture.png'], ImgAlts = [], ButtonURL="", ButtonText="Play", ImageOnLeft = false}) {
    var imgs = (
        <div className='ShowcaseImage'>
            <Gallery ImageURLs={ImgURLs} ImgAlts={ImgAlts}/>
        </div>
    );
    var content = (
        <div className='ShowcaseContent'>
            <ShowcaseDesc
                Title={Title}
                Date={Date}
                ButtonURL={ButtonURL}
                ButtonText={ButtonText}
            >
                {children}
            </ShowcaseDesc>
        </div>
    );

    if (ImageOnLeft) {
            content = (
                <>
                    {imgs}
                    {content}
                </>
            );
        }
        else {
            content = (
                <>
                    {content}
                    {imgs}
                </>
            );
        }
    
    return(
        <div className="Showcase">
            {content}
        </div>
    );
}

export default ShowcaseGallery;